<template>
  <div class="side-bar" :class="{ disabled: disabled }">
    <div class="side-bar-header">
      <h1 class="side-bar-header-title">
        {{ $t('mine.chat.recommend') }}
      </h1>
      <button class="close-button" @click="$emit('close')">
        {{ $t('mine.chat.close') }}
        <i class="icon icon--close-size16"></i>
      </button>
    </div>
    <div class="side-bar-body">
      <section class="section">
        <h2 class="section-title">
          {{ $t('mine.chat.questions.first.title') }}
        </h2>
        <ol class="section-list">
          <li class="section-list-item" v-for="(q, i) in questionList1" :key="i">
            <span class="question-button" @click="handleSubmit(q[$i18n.locale])">
              {{ q[$i18n.locale] }}
            </span>
          </li>
        </ol>
      </section>
      <section class="section">
        <h2 class="section-title">
          {{ $t('mine.chat.questions.second.title') }}
        </h2>
        <ol class="section-list">
          <li class="section-list-item" v-for="(q, i) in questionList2" :key="i">
            <span class="question-button" @click="handleSubmit(q[$i18n.locale])">
              {{ q[$i18n.locale] }}
            </span>
          </li>
        </ol>
      </section>
      <section class="section">
        <h2 class="section-title">
          {{ $t('mine.chat.questions.Third.title') }}
        </h2>
        <ol class="section-list">
          <li class="section-list-item" v-for="(q, i) in questionList3" :key="i">
            <span class="question-button" @click="handleSubmit(q[$i18n.locale])">
              {{ q[$i18n.locale] }}
            </span>
          </li>
        </ol>
      </section>
    </div>
  </div>
</template>

<script>
import messages from '@/data/i18n-messages.json'

export default {
  name: 'ChatSideBar',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      questionList1: messages.messages.mine.chat.questions.first.question,
      questionList2: messages.messages.mine.chat.questions.second.question,
      questionList3: messages.messages.mine.chat.questions.Third.question
    }
  },
  methods: {
    handleSubmit (question) {
      if (this.disabled) return
      this.$emit('submit', { prompt: question })
    }
  }
}
</script>

<style lang="scss" scoped>
.side-bar {
  flex: 0 0 0%;
  width: 384px;
  height: 100%;
  transition: all 0.3s ease-in-out;
  background-color: #d9d9d9;
  &-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 384px;
    height: 60px;
    padding: 0 32px;
    border-bottom: 1px solid #F0F0F0;
    box-sizing: border-box;
    &-title {
      color: #262626;
      font-size: 18px;
      font-weight: 600;
    }
    .close-button {
      @include flexYcenter;
      gap: 8px;
      padding: 10px 12px;
      border-radius: 5px;
      border: 1px solid #BBB;
      background-color: #FFF;
      color: #595959;
      font-size: 14px;
      font-weight: 600;
      .icon {
        background-color: transparent;
      }

      &:hover {
        background-color: #F4F4F4;
      }

      &:active {
        background-color: #E6E6E6;
      }
    }
  }

  &-body {
    display: flex;
    flex-direction: column;
    gap: 40px;
    height: calc(100% - 61px);
    padding: 20px 32px;
    box-sizing: border-box;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 16px;
    }

    &::-webkit-scrollbar-thumb {
      height: 30%;
      background: #8C8C8C;
      border-radius: 16px;
      border: 4px solid #d9d9d9;
    }

    &::-webkit-scrollbar-track {
      background: none;
    }
    .section {
      &-title {
        color: #444;
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 16px;
      }

      &-list {
        list-style: auto;
        padding-left: 20px;
        &-item {
          padding: 5px 0;
          .question-button {
            font-size: 14px;
            line-height: 1.5;
            color: #0074FF;
            text-decoration: underline;
            cursor: pointer;
          }
        }
      }
    }
  }

  &.disabled {
    .question-button {
      pointer-events: none;
    }
  }
}
</style>
